export const BillboardValidation = (json) => {
  const MyPromiss = new Promise((resolve, reject) => {
    var errorJson = {};

    // Helper function to safely handle string operations
    const safeStringTrim = (value) => {
      if (value === null || value === undefined) return '';
      return typeof value === 'string' ? value.trim() : String(value).trim();
    };

    // Duration validation
    if (!json?.duration) {
      Object.assign(errorJson, { duration: "Duration cannot be empty *" });
    } else {
      const durationValue = parseFloat(json.duration);
      if (isNaN(durationValue)) {
        Object.assign(errorJson, { duration: "Duration must be a valid number *" });
      } else if (durationValue < 1) {
        Object.assign(errorJson, { duration: "Duration must be at least 1 second *" });
      }
    }

    // File Type validation
    if (!json?.type) {
      Object.assign(errorJson, { type: "File type is required *" });
    }

    // Device ID validation
    if (!json?.deviceId) {
      Object.assign(errorJson, { deviceId: "Device is required *" });
    }

    // Source validation (image/video URL)
    if (!json?.source || safeStringTrim(json.source) === '') {
      Object.assign(errorJson, { source: "Media file is required *" });
    }

    resolve(errorJson);
  });

  return MyPromiss;
};